import { HYDRATE_STATE } from '../hydration'
import {
    UPDATE_LIST, UPDATE_PAGE, QUERY_LIST, RESET_LIST, UPDATE_PAGE_SIZE, UPDATE_SORT, LIST_QUERY_ERROR,
} from './actions'

/**
 * @typedef {Object} ListState State of the list integration
 *
 * @property {Array} items Array of selected items
 * @property {number} page Current list page
 * @property {number} pageSize Number of results on one page
 * @property {number} [count] Total amount of items
 * @property {boolean} isQuerying Loading state while querying
 * @property {string} [sort] Field to sort by
 * @property {"ASC"|"DESC"} [order] Ascending or descending order
 * @property {string} [errorMessage] An error message to show when a query failed
 */

const DEFAULT_PAGE_SIZE = 20

/** @type {ListState} */
const initialState = {
    items: [],
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    count: null,
    isQuerying: true,
    sort: null,
    order: null,
    errorMessage: null,
}

/**
 * Updates the state according to a dispatched action.
 * @param {ListState} state Current state
 * @param {Object} action Handled action
 * @returns {ListState} New state object
 */
export default function listReducer(state = initialState, action) {
    switch (action.type) {
        case HYDRATE_STATE:
            return {
                ...state,
                ...action.state,
            }

        case UPDATE_LIST:
            return {
                ...state,
                items: action.items,
                page: action.page,
                count: action.count,
                isQuerying: false,
                errorMessage: null,
            }

        case UPDATE_PAGE:
            return {
                ...state,
                page: action.page,
            }

        case QUERY_LIST:
            return {
                ...state,
                isQuerying: true,
            }

        case RESET_LIST:
            return {
                ...initialState,
                pageSize: state.pageSize,
                sort: state.sort,
                order: state.order,
            }

        case UPDATE_PAGE_SIZE:
            return {
                ...state,
                pageSize: action.pageSize,
            }

        case UPDATE_SORT:
            return {
                ...state,
                sort: action.sort,
                order: action.order,
            }

        case LIST_QUERY_ERROR:
            return {
                ...state,
                items: [],
                count: null,
                isQuerying: false,
                errorMessage: action.message,
            }

        default:
            return state
    }
}
